export const LISTE_LOT_PAIEMENT = {
  titre: 'Liste des lots de paiement',
  titreRecette: 'Liste des lots de paiement titre de recette',
  titreFactureAchat: 'Liste des lots de paiement factures achat',
  breadcrumb: {
    accueil: 'Accueil',
    listeLotPaiement: 'Liste des lots de paiement',
  },
  dataTable: {
    num: 'N° de lot de paiement',
    nbPaiement: 'Nb paiement',
    modePaiement: 'Mode de paiement',
  },
  lotN: 'Lot N°',
  lot: 'Lot',
  recherche: 'Rechercher',
  actions: {
    genererEcriture: 'Générer écritures comptables',
  },
  error: {
    noActionSelect: 'Aucune action sélectionnée',
  },
  generationEcriture: {
    title: 'Voulez-vous générer les écritures comptables pour les lots sélectionnés ?',
    success: 'Les écritures ont été générées avec succès.',
  },
  filtre: {
    title: 'Filtre',
    codeLot: 'Lots paiement {code}',
    sousTitle: 'Les filtres seront appliqués à la liste',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    modeReglement: 'Mode(s) de paiement',
    banque: 'Banque(s)',
    date: 'Date remise',
    exporteeEnCompta: 'Exportée en compta',
    exporteeEnComptaAnswer: {
      yes: 'Oui',
      no: 'Non',
    },
    etat: 'Etat',
  },
};

export const DETAIL_LOT_PAIEMENT = {
  titleDetail: 'Détail {lotPaiement}',
  breadcrumb: {
    accueil: 'Accueil',
    listeLotPaiement: 'Liste des lots de paiement',
    detail: 'Détail {lotPaiement}',
  },
  onglet: {
    fichierVirement: 'Fichiers de virement',
  },
  actions: {
    validation: 'Valider le lot de paiement',
    devalidation: 'Dévalider le lot de paiement',
    virementSepa: 'Virement SEPA',
    editionReferencePaiement: 'Attribuer un numéro de chèque',
    suppressionPaiement: 'Supprimer les paiements',
    suppression: 'Suppression',
  },
  suppression: {
    title: 'Etes-vous sûr de vouloir supprimer le lot de paiement ?',
    checkbox: 'Supprimer les constatations de charges',
  },
  edition: {
    lettreChequeFace: 'Lettre chèque détail à la face',
    lettreChequeDispositif: 'Lettre chèque détail au dispositif',
    chequeManuelFace: 'Chèque manuel détail à la face',
    chequeManuelDispositif: 'Chèque manuel détail au dispositif',
    VirementFace: 'Virement détail à la face',
    VirementDispositif: 'Virement détail au dispositif',
    numero1cheque: 'Numéro du premier chèque',
    lotPaiementBaux: 'Edition des baux',
  },
  tab: {
    datePaiement: 'Date de paiement',
    fournisseur: 'Fournisseur',
    referencePaiement: 'Référence paiement',
    nomTire: 'Nom tiré',
    dateEffet: 'Date d\'effet',
    montant: 'Montant',
  },
  informations: {
    title: 'Informations lot paiement',
    banque: 'Banque :',
    libelle: 'Libelle :',
    agence: 'Agence :',
    modePaiement: 'Mode de paiement :',
    datePaiement: 'Date de paiement :',
  },
  messages: {
    success: {
      virementSepa: 'Le fichier SEPA a bien été généré. Il a été ajouté à vos fichiers de virements',
      suppression: 'Le lot de paiement a été supprimé',
    },
    error: {
      virementBankIbanEmpty: 'L\'Iban de la domiciliation bancaire est vide',
      virementBankBicEmpty: 'Le Bic/swift de la domiciliation bancaire est vide',
      virementBankSepaIdEmpty: 'L\'identifiant SEPA de la domiciliation bancaire est vide',
      virementBankInactive: 'La domicilitation bancaire est inactive',
      virementBankHolderEmpty: 'Le titulaire de la domiciliation bancaire est vide',
      virementBankNameEmpty: 'Le nom de la banque de la domiciliation bancaire est vide',
      virementLineAmountLessEqualZero: 'Une des lignes de paiement a un montant de débit inférieur ou égal à zéro',
      virementLineCountEmpty: 'Au moins un paiement à traiter est requis',
      virementLinePersonEmpty: 'Une des lignes de paiement n\'a pas de tiers',
      virementLinePersonHolderEmpty: 'Le titulaire du RIB pour le tiers {bailleur} est vide',
      suppressionFacture: 'Le lot de paiement ne peut être supprimé car au moins une facture n\'est pas supprimable',
      suppressionTypeAchat: 'Le lot de paiement ne peut être supprimé car il devrait être de type achat (lot de paiement)',
      suppressionAnnulation: 'Le lot de paiement ne peut être supprimé car il contient une annulation de règlement',
      suppressionValide: 'Le lot de paiement ne peut être supprimé car il est validé',
      iban: {
        length: 'La longueur de l\'IBAN du bailleur {bailleur} n\'est pas correct',
        countryCodeUnsupported: 'Le code de pays de l\'IBAN du bailleur {bailleur} n\'est pas supporté',
        countryCodeUpperCaseLetters: 'Le code du pays de l\'IBAN du bailleur {bailleur} doit-être en majuscule',
        invalidCheckDigitValue: 'Les chiffres de contrôle d\' l\'IBAN du bailleur {bailleur} sont invalides',
        genericError: 'L\'IBAN du bailleur {bailleur} est incorrect',
        ibanNotEmptyOrNull: 'L\'IBAN du bailleur {bailleur} ne doit pas être vide',
      },
      bic: {
        length: 'Le bic du bailleur {bailleur} doit contenir 8 caractères ou 11 caractères',
        branchCodeOnlyLettersOrDigit: 'Le code de la branche du bailleur {bailleur} doit contenir seulement des lettres ou des chiffres',
        countryCodeUnsupported: 'Le code de pays du BIC du bailleur {bailleur} n\'est pas supporté',
        genericError: 'Le BIC du bailleur {bailleur} est incorrect',
        bicNotEmptyOrNull: 'Le BIC du bailleur {bailleur} ne doit pas être vide',
      },
      checksNumberMissing: 'Le numéro de chèque est obligatoire',
      mustBePdf: 'L\'édition de lettre chèque doit être en pdf',
      parametrageMissing: 'Le paramètrage des lettres chèques est manquant pour cette domiciliation bancaire',
    },
  },
  msgError: {
    errSuppEcritCompta: 'Une erreur s\'est produite lors du processus de suppression des écritures comptables associées',
    errDevalidRemiseBanc: 'Le lot de paiement ne peut être dévalidée car des écritures comptables associées sont placées dans des lots',
  },
};

export const EDIT_LOT_PAIEMENT = {
  title: 'Modification ',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des lots de paiement',
    modif: 'Modification lot paiement',
  },
  popUpEditionReferencePaiement: {
    title: 'Attribuer un numéro de chèque',
    referencePaiement: 'Premier numéro',
  },
  informations: {
    title: 'Informations lot paiement',
    banque: 'Banque',
    modePaiement: 'Mode de paiement',
    datePaiement: 'Date de paiement',
    libelle: 'Libelle',
  },
  messages: {
    successUpdate: 'Lot de paiement modifié avec succès',
  },
};
